import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { QuizApi } from "../../../../api/quiz";
import { QuizItem } from "../QuizItem/QuizItem";
import { useAuth } from "../../../../hooks";
import "./ListQuiz.scss";

export function ListQuiz({ reload, onReload }) {
  const { accessToken, user } = useAuth();
  const [quizzes, setQuizzes] = useState(null);
//quizz list
  useEffect(() => {
    (async () => {
      try {
        // Obtenemos sólo los quizzes de este teacher
        const result = await new QuizApi().getAllQuizzes(
          accessToken,
          user.user.teacher
        );
        setQuizzes(result.quizzes || []);
      } catch (error) {
        console.error("Error cargando quizzes:", error);
        setQuizzes([]);
      }
    })();
  }, [accessToken, user.user.teacher, reload]);

  if (quizzes === null) return <Loader active inline="centered" />;

  if (quizzes.length === 0) {
    return <h2 className="list-quiz__empty">No hay Quizzes</h2>;
  }

  return (
    <div className="list-quiz">
      <div className="list-quiz__items">
        {quizzes.map((quiz) => (
          <QuizItem key={quiz._id} quiz={quiz} onReload={onReload} />
        ))}
      </div>
    </div>
  );
}
